import { Link, NavLink, Navigate, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LayoutDashboard, Package, FolderTree, LogOut, Hammer, ExternalLink, Settings, ShoppingCart, Receipt } from "lucide-react";

export default function AdminLayout() {
    const { user, loading, logout } = useAuth();
    const nav = useNavigate();

    if (loading) return <div className="p-10 text-center font-mono text-sm">Cargando…</div>;
    if (!user) return <Navigate to="/admin/login" replace />;

    const linkCls = ({ isActive }) =>
        `flex items-center gap-3 px-4 py-3 text-xs uppercase tracking-widest font-bold border-l-4 transition-colors ${
            isActive
                ? "bg-[var(--lz-orange)] text-[var(--lz-navy)] border-white"
                : "text-white/80 border-transparent hover:bg-white/5 hover:text-white"
        }`;

    return (
        <div className="min-h-screen flex bg-[#f3f4f6]" data-testid="admin-layout">
            <aside className="w-64 bg-[var(--lz-navy)] text-white flex-shrink-0 hidden md:flex md:flex-col sticky top-0 h-screen">
                <div className="p-5 border-b border-white/10 flex items-center gap-2">
                    <span className="inline-flex items-center justify-center w-9 h-9 bg-[var(--lz-orange)] text-[var(--lz-navy)]"><Hammer className="w-5 h-5" /></span>
                    <div className="leading-none">
                        <div className="font-display font-bold text-base uppercase">Lozmar</div>
                        <div className="text-[10px] uppercase tracking-[0.3em] text-[var(--lz-orange)]">Admin</div>
                    </div>
                </div>
                <nav className="py-2 flex-1">
                    <NavLink to="/admin" end className={linkCls} data-testid="admin-nav-dashboard"><LayoutDashboard className="w-4 h-4" />Dashboard</NavLink>
                    <NavLink to="/admin/productos" className={linkCls} data-testid="admin-nav-products"><Package className="w-4 h-4" />Productos</NavLink>
                    <NavLink to="/admin/pos" className={linkCls} data-testid="admin-nav-pos"><ShoppingCart className="w-4 h-4" />Punto de venta</NavLink>
                    <NavLink to="/admin/cortes" className={linkCls} data-testid="admin-nav-cortes"><Receipt className="w-4 h-4" />Cortes de caja</NavLink>
                    <NavLink to="/admin/categorias" className={linkCls} data-testid="admin-nav-categories"><FolderTree className="w-4 h-4" />Categorías</NavLink>
                    <NavLink to="/admin/configuracion" className={linkCls} data-testid="admin-nav-settings"><Settings className="w-4 h-4" />Configuración</NavLink>
                </nav>
                <div className="p-3 border-t border-white/10 space-y-2">
                    <Link to="/" className="flex items-center gap-2 text-xs uppercase tracking-widest text-white/70 hover:text-[var(--lz-orange)]" data-testid="admin-go-store">
                        <ExternalLink className="w-3 h-3" /> Ver tienda
                    </Link>
                    <button onClick={async () => { await logout(); nav("/admin/login"); }} className="w-full flex items-center gap-2 text-xs uppercase tracking-widest text-white hover:text-[var(--lz-orange)]" data-testid="admin-logout">
                        <LogOut className="w-3 h-3" /> Cerrar Sesión
                    </button>
                    <div className="text-[10px] text-white/40 font-mono pt-2">
                        {user.email}
                        {user.role === "superadmin" && (
                            <span className="block text-[var(--lz-orange)] font-bold uppercase mt-0.5">Superadmin</span>
                        )}
                    </div>
                </div>
            </aside>

            <main className="flex-1 min-w-0">
                {/* Mobile top bar */}
                <div className="md:hidden bg-[var(--lz-navy)] text-white p-4 flex items-center justify-between">
                    <Link to="/admin" className="font-display font-bold uppercase">Admin Lozmar</Link>
                    <button onClick={async () => { await logout(); nav("/admin/login"); }} className="text-xs uppercase font-bold">Salir</button>
                </div>
                <div className="md:hidden flex border-b border-[var(--lz-navy)]/15 bg-white">
                    <NavLink to="/admin" end className={({ isActive }) => `flex-1 text-center text-[10px] uppercase font-bold py-3 ${isActive ? "bg-[var(--lz-orange)]" : ""}`}>Dashboard</NavLink>
                    <NavLink to="/admin/productos" className={({ isActive }) => `flex-1 text-center text-[10px] uppercase font-bold py-3 ${isActive ? "bg-[var(--lz-orange)]" : ""}`}>Productos</NavLink>
                    <NavLink to="/admin/pos" className={({ isActive }) => `flex-1 text-center text-[10px] uppercase font-bold py-3 ${isActive ? "bg-[var(--lz-orange)]" : ""}`}>POS</NavLink>
                    <NavLink to="/admin/categorias" className={({ isActive }) => `flex-1 text-center text-[10px] uppercase font-bold py-3 ${isActive ? "bg-[var(--lz-orange)]" : ""}`}>Categorías</NavLink>
                    <NavLink to="/admin/configuracion" className={({ isActive }) => `flex-1 text-center text-[10px] uppercase font-bold py-3 ${isActive ? "bg-[var(--lz-orange)]" : ""}`}>Config</NavLink>
                </div>
                <Outlet />
            </main>
        </div>
    );
}
